export function getWordFormBasedOnTheCount(count, one, couple, more) {
    let options = [one, couple, more];
    return options[(count % 100 > 4 && count % 100 < 20) ? 2 : [2, 0, 1, 1, 1, 2][(count % 10 < 5) ? count % 10 : 5]];
}

export function getScoreTranslateForm(count) {
    return count % 10 === 1 ? 'балла' : 'баллов';
}